import React from 'react'
import cx from 'classnames'

import { Href } from 'components/navigation'
import { Image, Text } from 'components/dataDisplay'

import s from './SingleServiceCard.scss'


interface SingleServiceCardProps {
  className?: string
  title: string
  image: string
  text: string
  to: string
}

const SingleServiceCard: React.FunctionComponent<SingleServiceCardProps> = (props) => {
  const { className, title, text, image, to } = props

  return (
    <Href className={className} to={to}>
      <div className={cx(s.gradientBackground, s.serviceCard, 'flex flex-1 radius-24 justify-between overflow-hidden')}>
        <div className={cx(s.textWrapper, 'flex flex-col my-24px ml-24px')}>
          <Text
            message={title}
            size="h24"
          />
          <Text
            className={cx(s.secondLineClamp, s.text, 'mt-12px overflow-ellipsis webkit-box opacity-48')}
            message={text}
            size="t16-24"
          />
        </div>
        <Image className={s.image} src={image} alt={text} />
      </div>
    </Href>
  )
}

export default SingleServiceCard